import PropTypes from 'prop-types'

import { Icon } from '../display/icon'

const BudgetSpyglassIcon = ({ label = 'BudgetSpyglass', ...rest }) => {
  return (
    <Icon
      label={label}
      {...rest}
      dangerouslySetGlyph={`<svg data-name="Layer 1" viewBox="0 0 300 300"><path d="M264.2 274.2a10.2 10.2 0 0 1-7.1-2.9l-78.5-78.6a10 10 0 1 1 14.1-14.1l78.6 78.5a10.1 10.1 0 0 1 0 14.2 10.2 10.2 0 0 1-7.1 2.9z" style="fill:#1d1d1b"/><circle cx="121.1" cy="121" r="85.2" style="fill:#f4c223"/><path d="M121.1 35.8A85.3 85.3 0 1 1 35.8 121a85.1 85.1 0 0 1 85.3-85.2m0-10a95.2 95.2 0 0 0-67.4 162.6A95.2 95.2 0 1 0 188.4 53.7a94.6 94.6 0 0 0-67.3-27.9z" style="fill:#1d1d1b"/><path d="M149.5 137.9c0 11.9-9.3 21.5-20.7 21.8v7.9a3.8 3.8 0 0 1-3.9 3.8h-7.7a3.8 3.8 0 0 1-3.9-3.8v-7.9a27.9 27.9 0 0 1-15.2-5.5 3.9 3.9 0 0 1-.3-5.9l5.7-5.4a3.9 3.9 0 0 1 4.9-.4 11.5 11.5 0 0 0 6.2 1.8h13.7c3.1 0 5.7-2.9 5.7-6.4a6.4 6.4 0 0 0-4.3-6.2l-21.8-6.5a21.9 21.9 0 0 1-15.3-21c0-11.9 9.3-21.5 20.7-21.8v-7.8a3.8 3.8 0 0 1 3.9-3.9h7.7a3.8 3.8 0 0 1 3.9 3.9v7.8a27.9 27.9 0 0 1 15.2 5.5 3.9 3.9 0 0 1 .3 5.9l-5.7 5.4a3.9 3.9 0 0 1-4.9.4 11.5 11.5 0 0 0-6.2-1.8h-13.6c-3.2 0-5.8 2.9-5.8 6.4a6.4 6.4 0 0 0 4.3 6.2l21.8 6.5a21.9 21.9 0 0 1 15.3 21z" style="fill:#1d1d1b"/></svg>`}
    />
  )
}

BudgetSpyglassIcon.propTypes = {
  onClick: PropTypes.func,
  label: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.oneOf(['tiny', 'small', 'medium', 'large'])
}

export { BudgetSpyglassIcon }
